export default __webpack_public_path__ + "build/f2fff4e760a5f07f4ceec2c8f906abd6.svg";